module.exports = __webpack_public_path__ + "static/desertMenu-eeda78396f3ac286ac6e37f4684193c5.pdf";